import React, { useContext } from 'react';
import Modal from 'react-modal';

import { DataContext } from '../../context/DataContext';
import { declaracionSalud, declaracionSaludEje, goodBye } from '../../data/texts';
import { ImgAlert } from '../../svg';
import { customStyles } from '../../utils/constanst';
import DivRow from '../controls/DivRow';
import DropDownInput from '../controls/DropDownInput';
import Input from '../controls/Input';
import SwitchButton from '../controls/SwitchButton';

const Step3 = () => {  

    const { poliza, setPoliza, changeHandler} = useContext(DataContext);
    
    const sortArr = (a, b)=> a.orden > b.orden ? 1 : -1;

    const handleClick = (question, value) => {

        const { id } = question;

        setPoliza({
            ...poliza, 
            questions: [
                ...poliza.questions.filter(x => x.id !== id), 
                { ...question, value: value }
            ]
        })

    }

    const changeText = (question, text) => {

        setPoliza({ ...poliza, nCigar: text });

        const { id } = question;

        setPoliza(pol => ({
            ...pol, 
            questions: [
                ...pol.questions.filter(x => x.id !== id), 
                { ...question, text: text }
            ]
        }))

    }

    const changeValue = event => {

        const value = String(event.target.value).replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
        console.log(value);
        setPoliza({ ...poliza, [event.target.name]: value });

    }
   
    const closeModal = () => setPoliza({ ...poliza, showDialogQuestions: false });
    const closeModal2 = () => setPoliza({ ...poliza, showDialogRespQuestions: false });

    return (
        <div>
            <div className="reponsive">
                <div className="reponsive-width-6"> 
                    <div className='box-pl2-pr2'>
                        <DropDownInput label='Estatura' dataProvider='umestatura' 
                            value={poliza.estatura} 
                            onChange={changeValue}
                            valueSelect={poliza.estaturaUnidades} onChangeSelect={changeHandler}
                            field='estatura' 
                            fieldSelect='estaturaUnidades'                        
                            />
                        <DropDownInput label='Peso' dataProvider='umpeso'
                            value={poliza.peso} 
                            onChange={changeValue}
                            valueSelect={poliza.pesoUnidades} onChangeSelect={changeHandler}
                            field='peso' 
                            fieldSelect='pesoUnidades'                        
                            />
                    </div>
                </div>
                <div className="reponsive-width-6"> 
                    <SwitchButton si='Derecho' no='Zurdo' label="Lateralidad" value={poliza.lateralidad} onClick={value => setPoliza({...poliza, lateralidad: value})} />
                </div>                    
            </div>  
            { poliza.questions && poliza.questions.sort(sortArr).map(question => {

                const { id, pregunta, value = undefined, tipo, dependeDe } = question;

                let padreIsCheck = poliza.questions.find(x => x.numero === dependeDe)?.value  === true;

                return <div key={id}>

                    {tipo === 0 &&
                        <>
                            <div className="reponsive-width-8 mt-10"> 
                                <DivRow className="p-1">
                                    <div className="justify-text">{pregunta}</div>
                                </DivRow>
                            </div>
                            <div className="reponsive-width-4"> 
                                <DivRow className="p-1">
                                        <SwitchButton value={value} onClick={value => handleClick(question, value)} />
                                </DivRow>    
                            </div>
                                           
                        </> 
                    }
                    {tipo === 1 &&
                        <>
                            { padreIsCheck &&
                                <div className="reponsive-width-8 mt-10"> 
                                    <DivRow width='75%' className="p-1">
                                        <Input type='number' label={pregunta} value={poliza.nCigar} 
                                            onChange={e => changeText(question, e.target.value)}  />                                
                                    </DivRow>
                                </div>
                            }                                            
                        </> 
                    }
                </div> 
            }
            )}        
              
            <Modal
                isOpen={poliza.showDialogQuestions}
                onRequestClose={closeModal}
                style={customStyles}
                shouldCloseOnOverlayClick={false}
                contentLabel="Example Modal"
            >
                <h2 className="txt-primary">{declaracionSalud}</h2>
                <div className="dialog-center-content">
                    <ImgAlert />
                </div>
                <h5 className="txt-muted">{declaracionSaludEje}</h5>
                <h5 className="txt-primary">{goodBye}</h5>
                <div className="dialog-center-content">
                    <button type="button" className="control-button-btn btn-color-primary" onClick={closeModal}>Entendido</button>
                </div>
            </Modal>

            <Modal
                isOpen={poliza.showDialogRespQuestions}
                onRequestClose={closeModal2} 
                style={customStyles}
                shouldCloseOnOverlayClick={false}
                contentLabel="Example Modal"
            >
                <div className="dialog-center-content">
                    <ImgAlert />
                </div>
                <h3 className="txt-primary">Estimado cliente, debe contestar a cada una de las preguntas antes de continuar</h3>
                <div className="dialog-center-content">
                    <button type="button" className="control-button-btn btn-color-primary" onClick={closeModal2}>Entendido</button>
                </div>
            </Modal>
        </div>
    );
}

export default Step3;
